<div>
  <div class="form-label">
    {{ label }} <span *ngIf="required" class="required">*</span>
  </div>
  <div>
    <mat-form-field
      class="w-100 highlight-on-focus"
      (click)="select.open()"
      (keydown.enter)="select.open()"
      (keydown.space)="select.open()"
    >
      <mat-select
        #select
        [formControl]="control"
        [multiple]="multiple"
        name="multi-select"
        ngDefaultControl
        [aria-label]="selectAriaLabel"
      >
        <mat-option
          *ngFor="let option of options"
          value="{{ option }}"
          class="highlight-option"
          >{{ option }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div>
</div>
